// src
import dev from "./dev.json";
import preprod from "./preprod.json";
import prod from "./prod.json";

// see https://create-react-app.dev/docs/adding-custom-environment-variables/
const config = (() => {
  if (process.env.REACT_APP_ENV === "prod") return prod;
  if (process.env.REACT_APP_ENV === "preprod") return preprod;
  return dev;
})();

export default config;
